import {ReactNode} from 'react';

import type {DefaultTFuncReturn} from 'i18next';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, SxProps, Theme, Typography} from '@mui/material';

import {semantic} from '../../layouts/theme/designSystem';

const iconSx = {fontSize: 18, mt: 0.25, flexShrink: 0};

const messageSx = {fontSize: 13, lineHeight: 1.6};

export interface Props {
  text?: DefaultTFuncReturn;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

export const InfoBanner = ({text, children, sx}: Props) => {
  const containerSx = {
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
    borderRadius: '10px',
    px: 2,
    py: 1.5,
    bgcolor: semantic.info.bg,
    color: semantic.info.fg,
    ...sx,
  };

  const renderMessage = (): ReactNode => {
    if (text == null || text === '') {
      return null;
    }

    return (
      <Typography variant='body2' sx={messageSx}>
        {String(text)}
      </Typography>
    );
  };

  const content = children ?? renderMessage();

  return (
    <Box sx={containerSx}>
      <InfoOutlinedIcon sx={iconSx} />
      {content}
    </Box>
  );
};
